(function ($) {
  var searchOpen = false;
  $(document).on('click', '#js-toggle-search', function(e) {

    if($(window).width()< 992){
      $('#js-search-overlay').css('top', $('.header__top').outerHeight());
    } else {
      $('#js-search-overlay').css('top', $('header.header').outerHeight());
    }

    searchOpen = !searchOpen;
    if(!$('body').hasClass('search-results')){
      if(searchOpen){
        $('#js-search-overlay').fadeToggle();
        $('#js-search-overlay .form__input--search').focus();
      }
    } else {
      $('.search-page .form__input--search').focus();
    }
  });

  function closeSeach(){
    $('#js-search-overlay').fadeOut();
    searchOpen = false;
  }

  $(document).on('click', '#js-close-search', function(){
    closeSeach();
  });

  $(document).on('keyup', function (e) {
    // esc click
    if (e.key === 'Escape' || e.keyCode === 27) {
      closeSeach();
    }
  });

})(jQuery);
